// Author PanYuRou
// Date 2023-12-14 14:28:16

class BusinessModule {
    constructor({
                    id = null,
                    name = '',
                    code = '',
                    parentId = '',
                    maxFileSize = '',
                    maxFileUnit = '',
                    remark = ''
                }
                    = {}) {
        this.id = id;
        this.name = name;
        this.code = code;
        this.parentId = parentId;
        this.maxFileSize = maxFileSize;
        this.maxFileUnit = maxFileUnit;
        this.remark = remark;
    }
}

function newEntity() {
    return new BusinessModule();
}

function gridFields() {
    return Object.freeze([
        {
            key: 'name',
            label: 'label.em.admin.businessModule.grid.name',
            sortable: true,
            form: {
                type: 'input',
                modalMultiSelectedType: 'string'
            }
        },
        {
            key: 'code',
            label: 'label.em.admin.businessModule.grid.code',
            sortable: true,
            form: {
                type: 'input',
                modalMultiSelectedType: 'string'
            }
        },
        {
            key: 'parentId',
            label: 'label.em.admin.businessModule.grid.parentId',
            sortable: true,
            form: {
                type: 'input',
                modalMultiSelectedType: 'string'
            }
        },
        {
            key: 'maxFileSize',
            label: 'label.em.admin.businessModule.grid.maxFileSize',
            sortable: true,
            form: {
                type: 'input',
                modalMultiSelectedType: 'string'
            }
        },
        {
            key: 'maxFileUnit',
            label: 'label.em.admin.businessModule.grid.maxFileUnit',
            sortable: true,
            form: {
                type: 'select',
                modalMultiSelectedType: 'string'
                , options: [
                    {value: '1', text: 'B'},
                    {value: '2', text: 'KB'},
                    {value: '3', text: 'MB'},
                    {value: '4', text: 'GB'},
                    {value: '5', text: 'TB'}
                ]
            }
        },
        {
            key: 'createdTime',
            label: 'label.em.admin.businessModule.grid.createdTime',
            sortable: true,
            form: {
                type: 'input',
                modalMultiSelectedType: 'string'
            }
        },
        {
            key: 'createdBy',
            label: 'label.em.admin.businessModule.grid.createdBy',
            sortable: true,
            form: {
                type: 'input',
                modalMultiSelectedType: 'string'
            }
        },
        {
            key: 'updatedTime',
            label: 'label.em.admin.businessModule.grid.updatedTime',
            sortable: true,
            isDetail: true,
            form: {
                type: 'input',
                modalMultiSelectedType: 'string'
            }
        },
        {
            key: 'updatedBy',
            label: 'label.em.admin.businessModule.grid.updatedBy',
            sortable: true,
            isDetail: true,
            form: {
                type: 'input',
                modalMultiSelectedType: 'string'
            }
        },
        {
            key: 'remark',
            label: 'label.em.admin.businessModule.grid.remark',
            sortable: true,
            isDetail: true,
            form: {
                type: 'textarea',
                modalMultiSelectedType: 'string'
            }
        }
    ])
}

const filter = {
    idFilter: '',
    idListFilter: [],
    nameFilter: '',
    codeFilter: '',
    parentIdFilter: '',
    maxFileSizeFilter: '',
    maxFileUnitFilter: ''
};

const fields = Object.freeze(Object.keys(newEntity()).map(i => 'entity.' + i));

const filterFields = Object.freeze(Object.keys(filter).map(i => 'filter.' + i));

const filterConfigs = [
    {
        key: 'nameFilter',
        label: 'label.em.admin.businessModule.filter.name',
        disabled: false,
        form: {
            type: 'input',
            modalMultiSelectedType: 'string'
        }
    },
    {
        key: 'codeFilter',
        label: 'label.em.admin.businessModule.filter.code',
        disabled: false,
        form: {
            type: 'input',
            modalMultiSelectedType: 'string'
        }
    },
    {
        key: 'parentIdFilter',
        label: 'label.em.admin.businessModule.filter.parentId',
        disabled: false,
        form: {
            type: 'input',
            modalMultiSelectedType: 'string'
        }
    },
    {
        key: 'maxFileSizeFilter',
        label: 'label.em.admin.businessModule.filter.maxFileSize',
        disabled: false,
        form: {
            type: 'input',
            modalMultiSelectedType: 'string'
        }
    },
    {
        key: 'maxFileUnitFilter',
        label: 'label.em.admin.businessModule.filter.maxFileUnit',
        disabled: false,
        form: {
            type: 'select',
            modalMultiSelectedType: 'string'
            , showLabelSelectOne: true
            , options: [
                {value: '1', text: 'B'},
                {value: '2', text: 'KB'},
                {value: '3', text: 'MB'},
                {value: '4', text: 'GB'},
                {value: '5', text: 'TB'}
            ]
        }
    }
];


const entityFormConfigs = [
    {
        key: 'name',
        label: 'label.em.admin.businessModule.entity.name',
        sortable: true,
        disabled: false,
        form: {
            type: 'input',
            modalMultiSelectedType: 'string'
        }
    },
    {
        key: 'code',
        label: 'label.em.admin.businessModule.entity.code',
        sortable: true,
        disabled: false,
        form: {
            type: 'input',
            modalMultiSelectedType: 'string'
        }
    },
    {
        key: 'parentId',
        label: 'label.em.admin.businessModule.entity.parentId',
        sortable: true,
        disabled: false,
        form: {
            type: 'input',
            modalMultiSelectedType: 'string'
        }
    },
    {
        key: 'maxFileSize',
        label: 'label.em.admin.businessModule.entity.maxFileSize',
        sortable: true,
        disabled: false,
        form: {
            type: 'input',
            modalMultiSelectedType: 'string'
        }
    },
    {
        key: 'maxFileUnit',
        label: 'label.em.admin.businessModule.entity.maxFileUnit',
        sortable: true,
        disabled: false,
        form: {
            type: 'select',
            modalMultiSelectedType: 'string'
            , showLabelSelectOne: true
            , options: [
                {value: '1', text: 'B'},
                {value: '2', text: 'KB'},
                {value: '3', text: 'MB'},
                {value: '4', text: 'GB'},
                {value: '5', text: 'TB'}
            ]
        }
    },
    {
        key: 'remark',
        label: 'label.em.admin.businessModule.entity.remark',
        sortable: true,
        disabled: false,
        form: {
            type: 'textarea',
            modalMultiSelectedType: 'string'
        }
    }
]

export {
    BusinessModule, newEntity, gridFields, fields, filterFields, filter, entityFormConfigs
    , filterConfigs


}
